/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".apply_special_pricing[_ngcontent-%COMP%]   .hz-field[_ngcontent-%COMP%]   .col-sm-5[_ngcontent-%COMP%]{margin-left:15px;padding:0;width:29%}.apply_special_pricing[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]:first-child   .col-sm-5[_ngcontent-%COMP%]{width:30.4%}\n/*# sourceMappingURL=specialpricing.component.css.map*/"];
export { styles as styles };
